import { CircularProgress } from '@mui/material';
import s from './Loader.module.scss';

const Loader = () => {
  return (
    <div className={s.root}>
      <CircularProgress size={32} />
    </div>
  );
};

export { Loader };
